import React from "react";
import { Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { apiErrorToast } from "Utils";
import { useDeleteReportLinkMutation } from "../../../services/sharedReports.api";

type DeleteReportLinkDialogProps = {
  purl: string;
  onClose: () => void;
  isOpen: boolean;
  token: string;
  linkName: string;
};

const DeleteReportLinkDialog = ({
  purl,
  onClose,
  isOpen,
  token,
  linkName,
}: DeleteReportLinkDialogProps): React.JSX.Element => {
  const [deleteReportLink] = useDeleteReportLinkMutation();

  const deleteLink = async () => {
    try {
      await deleteReportLink({
        token_key: token,
      }).unwrap();

      Toast.show({
        title: "Link has been deactivated",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not deactivate link");
      return;
    }

    onClose();
  };

  return (
    <Dialog
      title={
        <>
          Delete <em>{linkName}</em>
        </>
      }
      subtitle={<code>{purl}</code>}
      confirmText="Delete"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={deleteLink}
      cancelButtonColor="secondary"
      confirmButtonColor="primary"
    >
      <p>
        <strong>Are you sure you want to delete {linkName}? </strong>
      </p>
      <p>The existing ruleset and recipients will be deleted immediately.</p>
      <p>
        <strong>The report can be shared again</strong> at any time by
        generating a new link.
      </p>
    </Dialog>
  );
};

export default DeleteReportLinkDialog;
